/**
 * Greengrass v2 ComponentName identifiers (account-wide; no env segment).
 * Aligns with CCI product names (axon / matrix) and flat thing groups (`cci-*`).
 * @see docs/AWS_RESOURCE_NAMING_CCI.md §12
 */

export const GREENGRASS_EDGE_GUARD = 'com.cnapse.edge-device-guard' as const;

export const GREENGRASS_AXON_ORCHESTRATOR = 'com.cnapse.axon.orchestrator' as const;

export const GREENGRASS_MATRIX_ORCHESTRATOR = 'com.cnapse.matrix.orchestrator' as const;

const AXON_ADAPTER_PREFIX = 'com.cnapse.axon.adapter.';
const MATRIX_ADAPTER_PREFIX = 'com.cnapse.matrix.adapter.';

export function axonAdapterGreengrassComponentName(adapterKey: string): string {
  return `${AXON_ADAPTER_PREFIX}${adapterKey}`;
}

export function matrixAdapterGreengrassComponentName(adapterKey: string): string {
  return `${MATRIX_ADAPTER_PREFIX}${adapterKey}`;
}

/** IPC accessControl policy key for mqttproxy in orchestrator/guard recipes. */
export function greengrassMqttProxyPolicyKey(componentName: string, suffix = 'mqttproxy:1'): string {
  return `${componentName}:${suffix}`;
}
